module.exports = __webpack_public_path__ + "img/agpz-bus-selected.fd17519e.svg";